import React from 'react';
import PropTypes from 'prop-types';
import history from 'routing/history';
import {
  StyledProductButton,
  IconBg,
  IconBgLayer,
  IconContainer,
  Children,
  HoverChildren
} from './styled';

const ProductButton = ({
  color,
  productLink,
  icon,
  comingSoon,
  onMouseEnter,
  onMouseLeave,
  hoverChildren,
  children
}) => {
  const navigateToProduct = () => {
    if (!comingSoon) {
      history.push(productLink);
    }
  };

  return (
    <StyledProductButton
      color={color}
      onClick={() => navigateToProduct()}
      comingSoon={comingSoon}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <IconBg color={color} />
      <IconBgLayer color={color} />
      <IconContainer color={color}>
        {icon && <img src={icon} alt="product icon" />}
      </IconContainer>
      <Children comingSoon={comingSoon}>{children}</Children>
      {hoverChildren && <HoverChildren>{hoverChildren}</HoverChildren>}
    </StyledProductButton>
  );
};

ProductButton.propTypes = {
  children: PropTypes.node.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  hoverChildren: PropTypes.node,
  productLink: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string,
  comingSoon: PropTypes.bool
};

export default ProductButton;
